<template>
  <div>
    <img src="/assets/icons/hogcfd/year-stamp.webp" class="relative" />
    <p
      class="absolute top-[37px] left-[28px] rotate-[-10deg] font-my-type-of-font text-[1.5rem] leading-[2rem] font-bold"
    >
      {{ year }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    year: {
      type: String,
      required: true,
    },
  },
};
</script>
